import React from 'react';
import { NavLink } from 'react-router-dom';

const Sidebar = () => (
  <aside className="admin-sidebar d-flex flex-column">
    <div className="admin-sidebar-header">
      <div className="admin-sidebar-brand">Admin Panel</div>
      <span className="admin-sidebar-subtitle">Blue Nest Hotel</span>
    </div>
    <nav className="nav flex-column mt-3 admin-sidebar-nav">
      <NavLink
        to="/admin/news-events"
        className={({ isActive }) =>
          `admin-sidebar-link nav-link ${isActive ? 'admin-sidebar-link-active' : ''}`
        }
      >
        <span className="admin-sidebar-bullet" />
        <span>News & Events</span>
      </NavLink>
      <NavLink
        to="/admin/services"
        className={({ isActive }) =>
          `admin-sidebar-link nav-link ${isActive ? 'admin-sidebar-link-active' : ''}`
        }
      >
        <span className="admin-sidebar-bullet" />
        <span>Services</span>
      </NavLink>
      <NavLink
        to="/admin/contacts"
        className={({ isActive }) =>
          `admin-sidebar-link nav-link ${isActive ? 'admin-sidebar-link-active' : ''}`
        }
      >
        <span className="admin-sidebar-bullet" />
        <span>Contact Messages</span>
      </NavLink>
      <NavLink
        to="/admin/testimonials"
        className={({ isActive }) =>
          `admin-sidebar-link nav-link ${isActive ? 'admin-sidebar-link-active' : ''}`
        }
      >
        <span className="admin-sidebar-bullet" />
        <span>Testimonials</span>
      </NavLink>

      <div className="mt-auto pt-3">
        <NavLink
          to="/"
          className="admin-sidebar-link nav-link admin-sidebar-back"
        >
          ← Back to Site
        </NavLink>
      </div>
    </nav>
  </aside>
);

export default Sidebar;
